import { render, staticRenderFns } from "./CreateClassScheduleFile.vue?vue&type=template&id=4c20327e&scoped=true"
import script from "./CreateClassScheduleFile.vue?vue&type=script&lang=js"
export * from "./CreateClassScheduleFile.vue?vue&type=script&lang=js"
import style0 from "./CreateClassScheduleFile.vue?vue&type=style&index=0&id=4c20327e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c20327e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c20327e')) {
      api.createRecord('4c20327e', component.options)
    } else {
      api.reload('4c20327e', component.options)
    }
    module.hot.accept("./CreateClassScheduleFile.vue?vue&type=template&id=4c20327e&scoped=true", function () {
      api.rerender('4c20327e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/CreateClassScheduleFile.vue"
export default component.exports